import '@babel/polyfill'
import 'unfetch/polyfill'

import './ChildNode.replaceWith'

import URLSearchParams from '@ungap/url-search-params'
if ('URLSearchParams' in window === false) {
  window.URLSearchParams = URLSearchParams
}
